export default __webpack_public_path__ + "static/media/NoQuoteSadImage.921dd898.svg";